import React from 'react';

// Inline SVG icons. Unicode glyphs such as U+23F8 (pause) render as emoji
// with their own backgrounds on iOS, so the strip and dock use these instead.
const Svg = ({ size = 22, children, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    {children}
  </svg>
);

export const PlayIcon = (props) => (
  <Svg {...props}><path d="M8 5.5v13a1 1 0 0 0 1.53.85l10.2-6.5a1 1 0 0 0 0-1.7L9.53 4.65A1 1 0 0 0 8 5.5z" /></Svg>
);

export const PauseIcon = (props) => (
  <Svg {...props}><rect x="6" y="5" width="4.5" height="14" rx="1" /><rect x="13.5" y="5" width="4.5" height="14" rx="1" /></Svg>
);

export const StopIcon = (props) => (
  <Svg {...props}><rect x="6" y="6" width="12" height="12" rx="2" /></Svg>
);

// A metronome: tapered body with a pendulum arm.
export const MagnifierIcon = (props) => (
  <Svg {...props} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
    <circle cx="10.5" cy="10.5" r="6" />
    <path d="M15 15l5 5" />
  </Svg>
);

export const MetronomeIcon = (props) => (
  <Svg {...props} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 4h6l3.5 16h-13L9 4z" />
    <path d="M12 16V10" />
    <path d="M12 10l4.5-4.5" />
    <circle cx="16.5" cy="5.5" r="1.3" fill="currentColor" stroke="none" />
    <path d="M7 20h10" />
  </Svg>
);

export const ChevronUpIcon = (props) => (
  <Svg {...props} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 15l6-6 6 6" />
  </Svg>
);

export const ChevronDownIcon = (props) => (
  <Svg {...props} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9l6 6 6-6" />
  </Svg>
);
